// Read configuration from meta tags (synchronous - no timing issues)
const cellMeta = document.querySelector('meta[name="app-cell"]');
const versionMeta = document.querySelector('meta[name="app-version"]');
const SECONDS_IN_YEAR = 365 * 24 * 60 * 60;

const cell = cellMeta?.getAttribute('content');
const version = versionMeta?.getAttribute('content');

// Do not manually edit this value. It's incremented by the azure pipeline
window.version = version || '0.0.0';

// Set cell cookie
if (cell && /^[a-z]$/i.test(cell)) {
  document.cookie =
    'Cell=' + cell.toLowerCase() + '; SameSite=Lax; Path=/; Max-Age=' + SECONDS_IN_YEAR + ';Secure';
}
